var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.college !== 'd9cdydbdh' || this.$route.path !=='/newsTrends')?_c('Header'):_vm._e(),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }